import { useCitadel } from "@/hooks/use-citadel";
import { EditWarehouseZoneModal } from "@/modals/stock/edit-warehouse-zone-modal";
import { useDisclosure } from "@msuite/ui/hooks";
import { createStandardMenuItems, Menu } from "@msuite/ui/menu";
import { type CellContext, RowActionsWrapper, useDataTableContext } from "@msuite/ui/table";
import { Fragment } from "@msuite/ui/utils";
import type { WarehouseZoneListItem } from "@msuite/utils/types";

export function RowActions({ cell }: CellContext<WarehouseZoneListItem, "actions">) {
	/** Context */
	const { refetch } = useDataTableContext();

	/** Hooks */
	const disclosure = useDisclosure();

	/** Query */
	const { citadel } = useCitadel();

	/** Computed */
	// The menu is an array of items, so the gate sits at the caller rather than in
	// a `<Can>` wrapper — same three-state guard as that component documents
	// (`apps/web/src/components/citadel/can.tsx`): dropped only on a definitive
	// denial, kept while the rules load so the server has the last word.
	const stockUpdateIsDenied = !!citadel && citadel.cannot("update", "Stock");
	const stockDeleteIsDenied = !!citadel && citadel.cannot("delete", "Stock");

	/** Render */
	return (
		<Fragment>
			<RowActionsWrapper to={`/organization/data/stock/warehouse-zone/${cell.row.original.id}`}>
				{(!stockUpdateIsDenied || !stockDeleteIsDenied) && (
					<Menu
						items={createStandardMenuItems({
							onEdit: stockUpdateIsDenied ? undefined : disclosure.onOpen,
						})}
					>
						<Menu.Button />
					</Menu>
				)}
			</RowActionsWrapper>
			{disclosure.isOpen && (
				<EditWarehouseZoneModal
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					onComplete={refetch}
					warehouseZoneId={cell.row.original.id}
				/>
			)}
		</Fragment>
	);
}
